import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/back.svg'


const _hoisted_1 = { class: "edit" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = {
  key: 0,
  class: "bookInfo"
}
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  key: 0,
  class: "length"
}
const _hoisted_7 = { class: "cateEdit" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "head" }
const _hoisted_10 = { class: "length" }
const _hoisted_11 = { class: "desc" }
const _hoisted_12 = { class: "children" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "head" }
const _hoisted_15 = { class: "length" }
const _hoisted_16 = { class: "desc" }
const _hoisted_17 = { class: "children" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "head" }
const _hoisted_20 = {
  key: 0,
  class: "length"
}
const _hoisted_21 = { class: "desc" }
const _hoisted_22 = { class: "contentEdit" }
const _hoisted_23 = {
  key: 0,
  style: {"height":"100%"}
}
const _hoisted_24 = {
  key: 1,
  class: "empty"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"}
}
const _hoisted_27 = { class: "codeItem" }
const _hoisted_28 = { class: "customTools" }
const _hoisted_29 = { class: "contentLength" }
const _hoisted_30 = { class: "textarea" }
const _hoisted_31 = { style: {"display":"flex"} }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { style: {"display":"flex"} }
const _hoisted_35 = { class: "contentDiff" }
const _hoisted_36 = { class: "contentDiffItem" }
const _hoisted_37 = { class: "countLength" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "contentDiffItem" }
const _hoisted_40 = {
  key: 0,
  class: "creating"
}
const _hoisted_41 = {
  key: 1,
  class: "countLength"
}
const _hoisted_42 = { style: {"display":"flex","justify-content":"flex-end","margin-top":"4px"} }
const _hoisted_43 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["src"]

import { onMounted, ref, computed } from 'vue';
import { ElMessage, ElMessageBox, ElButtonGroup, ElButton, ElInput, ElDropdown, ElDropdownMenu, ElDropdownItem, ElDialog } from 'element-plus'
import jsPDF from 'jspdf';

import Session from '@/plugins/session';
import { useRoute } from 'vue-router';
import router from '@/router/index'
import { get, post, put, Delete } from '@/plugins/request'
import modifyStr from './modifyStr';
import { ModelEnum } from '@/plugins/wenxinyiyanConfig';

type CateItem = {
  title: string,
  children: CateItem[],
  desc?: string,
  length?: number,
  contentId?: number[],
}
type Content = {
  id: number,
  content: string,
  length: number,
  zipDesc50: string,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'editor',
  setup(__props) {

const bookInfo = ref<{
  id: number;
  name: string;
  img: string;
  desc: string;
  problem: string;
  downUrl: string;
  createUserSystem: string;
  cateType: 1 | 2;
  sendWord: string;
}>();

const route = useRoute()
const cateJSON = ref<CateItem[]>([])
const chooseCate = ref<string[]>([])
const chooseCateInfo = ref<CateItem>()
const bookId = ref<number>(5);
const showContent = ref<Content[]>([])
const showContentLoading = ref<boolean>(false)
const createContentLoading = ref<boolean>(false)
const exporting = ref<boolean>(false)
const lockPage = ref<boolean>(false)

// 给一级类目增加二级展示框
const addCate1ChildCateVisible = ref<boolean>(false);
const addCate1ChildCateEditCat = ref<string[]>([]);
const addCate1ChildCateInput = ref<string>('')
const addCate1ChildCateAnswer = ref<string>('')
const addCate1ChildCateAnswerJSON = ref<string>('')
const addCate1ChildCateLoading = ref<boolean>(false)
let addChate1Session: Session;

// 生成新文字对比
const newContentVisible = ref<boolean>(false);
const newContentInput = ref<string>('');
const newContentOldContent = ref<Content>()
const newContentNewContent = ref<string>('')
const newContentLoading = ref<boolean>(false)
const newContentOldSelect = ref<{ start: number, end: number | undefined }>({ start: 0, end: undefined })
const newContentOldSelectText = ref<string>();// 给newContentOldSelect做校验

// 生成配图
const newImgVisible = ref<boolean>(false);
const newImgContent = ref<Content>()
const newImgCreateUrl = ref<string>('');
const baiduImgList = ref<string[]>([])

onMounted(() => {
  bookId.value = parseInt(route.params.id as string);
  initBookCate()
});

async function initBookCate() {
  lockPage.value = true
  const info = await get(`/bookInfo/${bookId.value}`)
  const cateObj = JSON.parse(info.cateJSON);
  bookInfo.value = info;
  cateJSON.value = cateObj;
  lockPage.value = false
  getAllLength();
}

async function getAllLength() {
  const allContId: number[] = []
  cateJSON.value.forEach(v => {
    if (v.contentId) {
      allContId.push(...v.contentId)
    }
    if (v.children) {
      v.children.forEach(vv => {
        if (vv.contentId) {
          allContId.push(...vv.contentId)
        }
        if (vv.children) {
          vv.children.forEach(vvv => {
            if (vvv.contentId) {
              allContId.push(...vvv.contentId)
            }
          })
        }
      })
    }
  })
  const allLength: {
    [key in number]: number;
  } = allContId.length ? await get('/bookAllLength/' + bookId.value) : []
  cateJSON.value.forEach(v => {
    if (v.contentId) {
      let length = 0;
      v.contentId.forEach(id => {
        length = allLength[id]
      })
      v.length = length;
    }
    if (v.children) {
      v.children.forEach(vv => {
        let length = 0;
        if (vv.contentId) {
          vv.contentId.forEach(id => {
            length += allLength[id];
          })
          vv.length = length;
        }
        if (vv.children) {
          vv.children.forEach(vvv => {
            if (vvv.contentId) {
              let length = 0;
              vvv.contentId.forEach(id => {
                length += allLength[id];
              })
              vvv.length = length;
            }
          })
        }
      })
    }
  })
}

async function changeChooseCate(item: CateItem, val: string[]) {
  if (item.children && item.children.length) {
    return;
  }
  showContent.value = []
  chooseCateInfo.value = item;
  if (item.contentId && item.contentId.length) {
    showContentLoading.value = true;
    try {
      const contentList: {
        [key in number]: Content
      } = await get('/getContentByIds', {
        contentIds: item.contentId
      })
      showContentLoading.value = false;
      showContent.value = Object.values(contentList);
      chooseCate.value = val;
    } catch (e: any) {
      showContentLoading.value = false;
      ElMessage.error(e);
    }
  } else {
    chooseCate.value = val;
  }
}
async function toCate1(afterCat1: CateItem, cate2: CateItem) {
  const rootIndex = cateJSON.value.indexOf(afterCat1);
  cateJSON.value.splice(rootIndex + 1, 0, cate2);
  const findIndex = afterCat1.children.indexOf(cate2);
  afterCat1.children.splice(findIndex, 1)
}
async function toCate2(afterCat1: CateItem, afterCat2: CateItem, cate3: CateItem) {
  const rootIndex1 = cateJSON.value.indexOf(afterCat1);
  const rootIndex2 = cateJSON.value[rootIndex1].children.indexOf(afterCat2);
  const findIndex = cateJSON.value[rootIndex1].children[rootIndex2].children.indexOf(cate3);
  cateJSON.value[rootIndex1].children.splice(rootIndex2 + 1, 0, cate3);
  afterCat2.children.splice(findIndex, 1)
}

function findChooseCat() {
  let find: CateItem = {
    title: '',
    desc: '',
    length: 0,
    children: cateJSON.value
  };
  for (let i = 0; i < chooseCate.value.length; i++) {
    const match = find.children.find(v => v.title === chooseCate.value[i])
    if (match) {
      find = match;
    }
  }
  return find;
}
async function createContent() {
  if (!bookInfo.value) {
    return
  }
  createContentLoading.value = true
  const find = findChooseCat();
  const chooseCateStr = chooseCate.value.join('/');
  const searchPropty = `你是${bookInfo.value.createUserSystem}，现在你要写一本名讲述${bookInfo.value.problem}的书。书名是《${bookInfo.value.name}》。
书的目录如下，锁进代表层级
\`\`\`text
${cateJSON.value.map(v => {
    let str = v.title
    if (v.children && v.children.length) {
      str += '\n'
      str += v.children.map(vv => {
        let str2 = '    ' + vv.title
        if (vv.children && vv.children.length) {
          str2 += '\n'
          str2 += vv.children.map(vvv => {
            return '        ' + vvv.title;
          }).join('\n')
        }
        return str2;
      }).join('\n')
    }
    return str;
  }).join('\n')}
\`\`\`
。正在写其中“${chooseCateStr}”这一章，${find.desc ? ('这一章内容是“' + find.desc + '”，') : ''}给出我这一章的内容。
## 内容特点
说的详细些，大于1300字。文章中不要有结语的章节。

## 格式要求
采用markdown格式。章节名称作为文章的开头，并用markdown一级标题。

## 示例
\`\`\`markdown
# ${chooseCateStr}
${bookInfo.value.cateType === 1 ? `
介绍文章的引言段落正文

## XXX

正文.........

## XXX

正文.........
` : `
段落1。
段落2。
`}
\`\`\`
"`
  const { id } = await post('/bookContent/create', {
    bookId: bookId.value,
    chooseCate: chooseCate.value,
    searchPropty,
    system: bookInfo.value.createUserSystem,
  }).catch((e) => {
    createContentLoading.value = false
    ElMessage.error(e);
  });
  if (id > 0) {
    if (!find.contentId) {
      find.contentId = [+id]
    } else {
      find.contentId.push(+id)
    }
    if (!find.desc) {
      const contentList: {
        [key in number]: Content
      } = await get('/getContentByIds', {
        contentIds: [id]
      })
      find.desc = contentList[id].zipDesc50
    }
    // await post('/book/bookUpdate/' + bookId.value, {
    //   cateJSON: cateJSON.value,
    // })
    if (chooseCateInfo.value) {
      await changeChooseCate(chooseCateInfo.value, chooseCate.value)
    }
    createContentLoading.value = false
    getAllLength();
  } else {
    createContentLoading.value = false
    ElMessage({
      message: '创建失败',
      type: 'error',
    })
  }
}
async function createAllContent() {
  const startDate = (new Date()).getTime()
  let stepStartDate = startDate;
  function showTime() {
    const useTime = Math.floor(((new Date()).getTime() - startDate) / 1000);
    const second = useTime % 60;
    const showTimeStr = useTime > 60 ? (Math.floor(useTime / 60) + '分钟' + (second ? second + '秒' : '')) : (useTime + '秒');
    const stepTime = Math.floor(((new Date()).getTime() - stepStartDate) / 1000)
    ElMessage.info({
      duration: 10000,
      message: `累计消耗${showTimeStr}，本次消耗${stepTime}秒`
    })
  }
  lockPage.value = true;
  for (let i = 0; i < cateJSON.value.length; i++) {
    const cate1 = cateJSON.value[i]
    if (!cate1.children || cate1.children.length === 0) {
      if (!cate1.contentId || cate1.contentId.length === 0) {
        await changeChooseCate(cate1, [cate1.title])
        stepStartDate = (new Date()).getTime();
        await createContent()
        showTime()
      }
    } else {
      for (let j = 0; j < cate1.children.length; j++) {
        const cate2 = cate1.children[j]
        if (!cate2.children || cate2.children.length === 0) {
          if (!cate2.contentId || cate2.contentId.length === 0) {
            await changeChooseCate(cate2, [cate1.title, cate2.title])
            stepStartDate = (new Date()).getTime();
            await createContent()
            showTime()
          }
        } else {
          for (let k = 0; k < cate2.children.length; k++) {
            const cate3 = cate2.children[k]
            if (!cate3.contentId || cate3.contentId.length === 0) {
              await changeChooseCate(cate3, [cate1.title, cate2.title, cate3.title])
              stepStartDate = (new Date()).getTime();
              await createContent()
              showTime()
            }
          }
        }
      }
    }
  }
  showMsgNotification('书内容创建完成', '书内容创建完成')
  lockPage.value = false;
}
function showCreateNewImg(content: Content) {
  baiduImgList.value = []
  newImgCreateUrl.value = '';
  newImgVisible.value = true;
  newImgContent.value = content;
  getNewContentImg();
}
function showCreateNewContent(content: Content) {
  newContentNewContent.value = ''
  newContentInput.value = ''
  newContentVisible.value = true
  newContentOldContent.value = content
}
async function getNewContent() {
  newContentNewContent.value = ''
  if (chooseCate.value.length === 0 || !bookInfo.value || newContentInput.value === '') {
    return
  }
  if (!newContentOldContent.value || !newContentOldSelect.value) {
    return;
  }
  createContentLoading.value = true
  const find = findChooseCat();
  newContentLoading.value = true;
  const bookSystem = bookInfo.value.createUserSystem;
  const oldContent = newContentOldContent.value.content.slice(newContentOldSelect.value.start,
    newContentOldSelect.value.end);
  const chooseCateStr = chooseCate.value.join('/')
  const session = new Session(bookInfo.value.createUserSystem);
  const result1 = await session.chat(`你是${bookSystem}，现在你要写一本名讲述${bookInfo.value.problem}的书。正在写其中《${chooseCateStr}》这一章，${(find.desc ? ('这一章讲述了“' + find.desc + '”') : '')}，你读懂就好，本地对话不用给我改写的结局，回复我“好的”即可。下一次对话，我会给你一些改写要求。
## 原有内容
\`\`\`markdown
${newContentOldContent.value.content}
\`\`\``, () => {
    console.log(1)
  })
  console.log('result1', result1)
  let promptSession = '';
  if (newContentOldSelect.value.end) {
    promptSession = `刚才的文章中有如下的文字：从${newContentOldSelect.value.start}字符开始的这段文字：“【${oldContent}】”，进行改写。改写建议是：“${newContentInput.value}”。
不要在开头加上类似“新内容如下：”或者“以下为您提供的这一章节的正文内容：”这一类的客套话。`
  } else {
    promptSession = `对刚才的文章进行改写，改写建议是：“${newContentInput.value}”。不要在开头加上类似“新内容如下：”，或者“以下为您提供的这一章节的正文内容：”这一类的客套话。
## 格式要求
采用markdown格式。如果让你去掉某部分内容，则字数肯定减少。如果让你增加某部分内容，则字数增加。这不是一篇独立的文章，而是一本书里的某一章，所以不要有引言。
章节名称作为文章的开头，并用markdown一级标题。
\`\`\`markdown
# ${chooseCateStr}
修改后的正文......
\`\`\`

## 示例
\`\`\`markdown
# ${chooseCateStr}
修改后的正文......`
  }
  console.log(promptSession)
  newContentNewContent.value = '';
  newContentNewContent.value = await session.chat(promptSession, (res) => {
    newContentNewContent.value += res
  })
  newContentVisible.value = true;
  newContentLoading.value = false;
  newContentInput.value = '';
  createContentLoading.value = false
}
async function deleteContent() {
  if (!chooseCateInfo.value || !bookInfo.value) {
    return;
  }
  ElMessageBox.confirm('是否清空文章', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    if (!chooseCateInfo.value || !bookInfo.value) {
      return;
    }
    chooseCateInfo.value.contentId = [];
    chooseCateInfo.value.length = 0;
    showContent.value = []
  }).catch((e) => {
    console.log(e)
  })
}
async function findError() {
  newContentNewContent.value = ''
  if (chooseCate.value.length === 0 || !bookInfo.value) {
    return
  }
  if (!newContentOldContent.value) {
    return;
  }
  const session = new Session(bookInfo.value.createUserSystem)
  createContentLoading.value = true
  newContentLoading.value = true;
  const newContent = await session.chat(`现在又一篇文章帮我看看有没有什么实事错误。
## 文章如下
${newContentOldContent.value.content.slice(newContentOldSelect.value.start,
    newContentOldSelect.value.end)}
`)
  newContentNewContent.value = newContent;
  newContentVisible.value = true;
  newContentLoading.value = false;
  createContentLoading.value = false
}
async function getNewContentImg() {
  if (!bookInfo.value || !chooseCateInfo.value) {
    return;
  }
  const session = new Session(bookInfo.value.createUserSystem);
  try {
    console.log(chooseCateInfo)
    let receiveMsg = newImgContent.value?.content;
    receiveMsg = await session.chat(`帮我把以下这么一段文字浓缩成一个可以30字以内的短描述，文字如下：
    ${receiveMsg}`)
    console.log(receiveMsg)
    receiveMsg = chooseCateInfo.value.title + ' ' + receiveMsg;
    const baiduUrl = 'https://image.baidu.com/search/acjson?tn=resultjson_com&word=' + encodeURIComponent(receiveMsg)
    const json = await get('https://api.studying1v1.com/admin/getHTTPByUrl?url=' + encodeURIComponent(baiduUrl));
    const urls = json.data.map((v: any) => v.hoverURL);
    baiduImgList.value = urls;
  } catch (e) {
    console.log(e)
  }
}
async function addImgToContent(url: string) {
  showContent.value[0].content += `\n![插图](${url})`;
  newImgVisible.value = false;
}
async function useNewContent() {
  if (newContentOldContent.value) {
    if (newContentOldSelect.value.end === undefined) {// 如果是undefined，代表全篇选中
      newContentOldContent.value.content = newContentNewContent.value;
    } else {
      newContentOldContent.value.content = newContentOldContent.value.content.slice(0, newContentOldSelect.value.start) + newContentNewContent.value + newContentOldContent.value.content.slice(newContentOldSelect.value.end)
    }
    newContentVisible.value = false;
    newContentNewContent.value = ''
  }
  newContentOldSelect.value = { start: 0, end: undefined }
}
async function splitContentToCat(content: Content, toParent: boolean) {
  if (!chooseCateInfo.value || !bookInfo.value) {
    return;
  }
  const session = new Session(bookInfo.value.createUserSystem);
  lockPage.value = true;
  await session.chat(`我给你一篇文章，标题是《${chooseCateInfo.value.title}》，我将给你正文，给你正文后你就回复我收到即可。后续的对话我会给你指令。
#内容如下
\`\`\`markdown
${content.content}
\`\`\``)
  const json = await session.chat(`这篇文章，你按照内容的段落分割，拆分成2个以上独立的部分，并给每个部分重新起个标题和一个50字以内的描述。
## 格式要求
你将返回json格式给我，示例如下：
\`\`\`json
[
  {
    "title": "标题",
    "desc": "短描述"
  },
  {
    "title": "标题",
    "desc": "短描述"
  }
]
\`\`\`
`)
  lockPage.value = false;
  const match = json.match(/```json([\S|\s]+)```/) as RegExpMatchArray;
  if (!match) {
    return;
  }
  console.log(match[1]);
  const children = JSON.parse(match[1]);
  const splitCateList: CateItem[] = children.map((v: any) => {
    return {
      title: v.title,
      desc: v.desc,
      children: []
    }
  })
  if (toParent) {
    if (cateJSON.value.includes(chooseCateInfo.value)) {
      const cate1Index = cateJSON.value.indexOf(chooseCateInfo.value);
      cateJSON.value.splice(cate1Index, 1, ...splitCateList)
    } else {
      for (let i = 0; i < cateJSON.value.length; i++) {
        const cate1 = cateJSON.value[i];
        if (cate1.children && cate1.children.includes(chooseCateInfo.value)) {
          const cate2Index = cate1.children.indexOf(chooseCateInfo.value);
          cate1.children.splice(cate2Index, 1, ...splitCateList)
          return
        } else {
          if (cate1.children && cate1.children.length) {
            for (let j = 0; j < cate1.children.length; j++) {
              const cate2 = cate1.children[j];
              if (cate2.children && cate2.children.includes(chooseCateInfo.value)) {
                const cate3Index = cate2.children.indexOf(chooseCateInfo.value)
                cate2.children.splice(cate3Index, 1, ...splitCateList)
              }
            }
          }
        }
      }
      console.log(chooseCateInfo.value);
      console.log(content);
    }
  } else {
    chooseCateInfo.value.children = splitCateList;
  }
  chooseCateInfo.value = undefined
  chooseCate.value = []
  showContent.value = []
}
async function saveContent(content: Content) {
  console.log(content);
  lockPage.value = true
  try {
    const result = await post('/book/contentUpdate/' + content.id, {
      content: content.content,
    });
    lockPage.value = false
    console.log(result);
    ElMessage({
      message: result ? `保存成功${result}个正文` : '保存正文不成功，或无修改',
      type: 'success',
    })
    if (chooseCateInfo.value) {
      changeChooseCate(chooseCateInfo.value, chooseCate.value)
      getAllLength();
    }
  } catch (e) {
    lockPage.value = false
    ElMessage({
      type: 'error',
      message: '保存失败：' + e
    })
  }
}

const allBookLength = computed(() => {
  let allLength = 0;
  cateJSON.value.forEach(v => {
    if (v.contentId && v.length) {
      allLength += v.length;
    }
    if (v.children) {
      v.children.forEach(vv => {
        if (vv.contentId && vv.length) {
          allLength += vv.length;
        }
        if (vv.children) {
          vv.children.forEach(vvv => {
            if (vvv.contentId && vvv.length) {
              allLength += vvv.length;
            }
          })
        }
      })
    }
  })
  return allLength;
})
async function saveBook() {
  // 整理数据
  cateJSON.value.forEach(v => {
    if (v.contentId && v.contentId.length) {
      v.contentId = v.contentId.filter(id => id).map(id => +id)
    }
    if (v.children && v.children.length > 0) {
      v.children.forEach(vv => {
        if (vv.contentId && vv.contentId.length) {
          vv.contentId = vv.contentId.filter(id => id).map(id => +id)
        }
        if (vv.children && vv.children.length > 0) {
          vv.children.forEach(vvv => {
            if (vvv.contentId && vvv.contentId.length) {
              vvv.contentId = vvv.contentId.filter(id => id).map(id => +id)
            }
          })
          vv.contentId = undefined;
          vv.length = undefined;
        }
      })
      v.contentId = undefined;
      v.length = undefined;
    }
  })
  const result = await put(`/bookInfo/${bookId.value}`, {
    data: {
      cateJSON: JSON.stringify(cateJSON.value)
    }
  })
  // 删除脏数据，无用的content
  let deleteIds: number[] = [];
  cateJSON.value.forEach(v => {
    if (v.children && v.children.length) {
      if (v.contentId && v.contentId.length) {
        deleteIds = [...deleteIds, ...v.contentId]
        delete v.contentId;
        v.length = 0;
      }
    }
  })
  console.log(deleteIds)
  if (deleteIds.length > 0) {
    const deleteResult = await Delete('/book/content/delete', {
      ids: deleteIds,
    })
    console.log('删除无用content结果', deleteResult);
  }
  ElMessage({
    message: result ? `目录保存成功` : '目录保存失败，或无修改',
    type: 'success',
  })
  initBookCate();
}
async function exportBook(isUpload: boolean) {
  let page = 0;
  function addPage() {
    doc.addPage()
    page++;
    const oldFontSize = doc.getFontSize();
    const oldFontColor = doc.getTextColor();
    doc.setTextColor('#777');
    doc.setFontSize(10);
    if (page % 2 === 0) {
      doc.text(page.toString(), 10, pageHeight - 7, { align: 'center' })
    } else {
      doc.text(page.toString(), pageWidth - 10, pageHeight - 7, { align: 'center' })
    }
    doc.setTextColor(oldFontColor);
    doc.setFontSize(oldFontSize);
  }
  function Content(beginY: number, doc: jsPDF) {
    let lineY = beginY;
    const marginTop = 12;
    const marginBottom = 12;
    const marginLeft = 20;
    const marginRight = 20;
    return {
      drawLine: async function (strContent: string, x: number, fontSize: number) {
        // fontSize正文的时候一般建议传10
        const lineHeight = fontSize * 0.7;
        doc.setFontSize(fontSize);
        if (strContent === undefined) {// 前期调试问题方便，稳定后可以删除
          // debugger
        }
        const strArr = strContent.split('\n');
        for (let j = 0; j < strArr.length; j++) {
          const strs_ = strArr[j]
          doc.setFont('sans')
          const wordList = modifyStr(strs_);
          let lineXPosition = x + marginLeft;
          // console.log('===wordList===', wordList);
          let maxFontSize = 10;
          for (let j = 0; j < wordList.length; j++) {
            const { word, style } = wordList[j];
            if (style.includes('img')) {
              const { width, height } = await (new Promise<{
                width: number,
                height: number,
              }>((resolve, reject) => {
                const img = new Image()
                img.onload = function () {
                  resolve({
                    width: img.width,
                    height: img.height,
                  })
                }
                img.onerror = function () {
                  reject('图片下载失败')
                }
                img.src = word
              }));
              const s = pageWidth * 0.6 / width
              console.log(width, height);
              const imgWidth = width * s;
              const imgHeight = height * s;
              if (pageHeight - marginBottom - marginTop - lineY < imgHeight) {
                addPage()
                lineY = 0;
              }
              doc.addImage(word, 'JPEG', (pageWidth - imgWidth) / 2, lineY + marginTop + lineHeight, imgWidth, imgHeight)
              lineY += imgHeight;
            } else if (style.includes('split')) {
              // doc.text("!!" + word + '!!!', lineXPosition, lineY + marginTop + lineHeight);
              // lineY += lineHeight;
            } else {
              // 处理样式
              const bold = style.includes('**')
              const T3 = style.includes('###') || style.includes('##') || style.includes('#')
              if (bold) {
                doc.setFont('sansBolds')
              } else {
                doc.setFont('sans')
              }
              if (T3) {
                doc.setFontSize(12)
                maxFontSize = Math.max(maxFontSize, 12)
              } else {
                maxFontSize = Math.max(maxFontSize, 10)
                doc.setFontSize(fontSize)
              }
              // 开始计算位置
              const width = doc.getTextWidth(word);
              if (lineXPosition + width > pageWidth - marginRight) {
                lineY += lineHeight;
                if (lineY > pageHeight - marginBottom - marginTop - lineHeight) {
                  addPage()
                  lineY = 0;
                }
                lineXPosition = x + marginLeft;
              }
              doc.text(word, lineXPosition, lineY + marginTop + lineHeight);
              lineXPosition += width;
            }
          }
          lineY += Math.max(maxFontSize, fontSize) * 0.7;
          if (lineY > pageHeight - marginBottom - marginTop - lineHeight) {
            addPage()
            lineY = 0;
          }
        }
      },
      addY(addNum: number) {
        lineY += addNum
      },
      getY() {
        return lineY + marginTop;
      },
      getBottomY() {
        return pageHeight - marginBottom - marginTop - lineY;
      },
      getPage() {
        return page;
      },
      turnNewPage() {
        addPage()
        lineY = 0;
      }
    }
  }
  exporting.value = true;
  if (!bookInfo.value) {
    return;
  }
  const doc = new jsPDF('p', 'mm', 'a5');
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();
  doc.setFont('sans');//使用字体时，使用这句即可
  function loadImg(url: string): Promise<HTMLImageElement> {
    return new Promise(resolve => {
      const image = new Image();
      image.onload = function () {
        // ctx.drawImage('https://yingshijiaoyuimg.oss-cn-beijing.aliyuncs.com/217766177edfc6998b7348135ce08100.png?x-oss-process=image/resize,m_fill,w_88,quality,q_60', 0, 0, 40, 30);
        resolve(image);
      };
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = url.replace(/^https?:/, '') as string; // 替换为你的图片路径
    })
  }
  // 开始创建封皮
  const titleY = 0.2;
  if (bookInfo.value && bookInfo.value.img) {
    // 创建封皮，用图片当背景
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    const image = await loadImg(bookInfo.value?.img.replace(/^https?:/, '') as string);
    canvas.width = image.width;
    canvas.height = image.height;
    ctx.drawImage(image, 0, 0, image.width, image.height);
    (() => {
      let titleFontSize = 48;
      for (; titleFontSize > 20; titleFontSize--) {
        ctx.font = titleFontSize + 'px Arial';
        const width = ctx.measureText(bookInfo.value?.name || '').width
        if (width < canvas.width * 0.8) {
          break;
        }
      }
      const nameWidth = ctx.measureText(bookInfo.value?.name || '').width;
      let descFontSize = 48;
      for (; descFontSize > 2; descFontSize--) {
        ctx.font = descFontSize + 'px Arial';
        const width = ctx.measureText(bookInfo.value?.desc || '').width
        if (width < canvas.width * 0.8) {
          break;
        }
      }
      const descTextWidth = ctx.measureText(bookInfo.value?.desc || '').width;
      // 绘制方块
      ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
      const scWidth = Math.max(nameWidth, descTextWidth) + canvas.width * 0.1;
      const scHeight = titleFontSize;
      ctx.fillRect(canvas.width / 2 - scWidth / 2, canvas.height * titleY - scHeight - 15, scWidth, scHeight + 170);
      ctx.strokeStyle = '#999';
      ctx.strokeRect(canvas.width / 2 - scWidth / 2, canvas.height * titleY - scHeight - 15, scWidth, scHeight + 170);
      // 绘制名称
      ctx.font = titleFontSize + 'px Arial';
      ctx.fillStyle = 'black';
      ctx.fillText(bookInfo.value?.name || '', canvas.width / 2 - nameWidth / 2, canvas.height * titleY)
      // 绘制描述
      ctx.fillStyle = '#333';
      ctx.font = descFontSize + 'px Arial';
      ctx.fillText(bookInfo.value?.desc || '', canvas.width / 2 - descTextWidth / 2, canvas.height * titleY + 100)
    })()
    // 绘制底部
    ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
    ctx.fillRect(canvas.width / 2 - 230, canvas.height - 135, 460, 90);
    const icon = await loadImg('https://yingshijiaoyuimg.oss-cn-beijing.aliyuncs.com/217766177edfc6998b7348135ce08100.png?x-oss-process=image/resize,m_fill,w_88,quality,q_60');
    ctx.drawImage(icon, canvas.width / 2 - 200 - 10, canvas.height - 123, 55, 50);
    ctx.font = '18px Arial';
    ctx.fillStyle = 'black';
    ctx.fillText('微述', canvas.width / 2 - 200, canvas.height - 56)
    ctx.fillStyle = 'black';
    ctx.font = '26px Arial';
    const bottomTextWidth2 = ctx.measureText('www.microbook123.com').width
    ctx.fillText('www.microbook123.com', canvas.width / 2 - bottomTextWidth2 / 2 + 30, canvas.height - 96)
    const bottomTextWidth = ctx.measureText('内部资料，非出版物，禁止销售').width
    ctx.fillStyle = '#666';
    ctx.font = '18px Arial';
    ctx.fillText('内部资料，非出版物，禁止销售', canvas.width / 2 - bottomTextWidth / 2 + 70, canvas.height - 65)
    doc.addImage(canvas.toDataURL("image/png"), 'JPEG', 0, 0, pageWidth, pageHeight)
  }
  // 封皮背面留白
  // 添加字体可以用这个教程，亲测有效 https://www.cnblogs.com/andydao/p/18060680
  const { default: addSansFont } = await import('./font/sans');
  const { default: addSansBoldsFont } = await import('./font/sansBold');
  addSansFont(doc)
  addSansBoldsFont(doc);
  (() => {
    doc.addPage()
    const { drawLine, getBottomY, addY } = Content(0, doc);
    doc.setTextColor('#333');
    drawLine('         ' + bookInfo.value.sendWord, 0, 11)
    const bottomY = getBottomY()
    addY(bottomY - 21);
    drawLine('         本专栏由微述网站发布，内容非出版物，网站不售卖任何纸质内容，所有纸质内容均为用户在网站下载后个人打印产生，任何个人打印后仅供个人学习使用，不得售卖。', 0, 8)
  })()

  const cateToPage = new Map<CateItem, number>()
  // 开始写正文
  let contEndPage = 0
  await (async function () {
    addPage()
    doc.setTextColor('#000');
    const allContId: number[] = []
    cateJSON.value.forEach(v => {
      if (v.contentId) {
        allContId.push(...v.contentId)
      }
      if (v.children) {
        v.children.forEach(vv => {
          if (vv.contentId) {
            allContId.push(...vv.contentId)
          }
          if (vv.children) {
            vv.children.forEach(vvv => {
              if (vvv.contentId) {
                allContId.push(...vvv.contentId)
              }
            })
          }
        })
      }
    })
    const contentList: {
      [key in number]: Content
    } = await get('/getContentByIds', {
      contentIds: allContId
    })
    const { drawLine, getY, getBottomY, getPage, addY, turnNewPage } = Content(0, doc);
    // let contIndex = 0;
    // drawLine('This is my first time to be here. I’m a little nervous.This is my first time to be here. I’m a little nervous.This is my first time to be here. I’m a little nervous.This is my first time to be here. I’m a little nervous.', 0, 20);
    //     drawLine(`### Title2
    // description
    // 1. **bold**:hello world.hello world.hello world.hello world.hello world.hello world.hello world.hello world.hello world.hello world`, 0, 10);
    //     drawLine(`1. **bold**:hello world`, 0, 20);
    for (let i = 0; i < cateJSON.value.length; i++) {
      const v = cateJSON.value[i]
      if (i !== 0) {
        turnNewPage();
      }
      doc.setFillColor('#4e6ef2')
      doc.rect(13, getY() + 4, pageWidth - 26, 14, 'F');
      doc.setTextColor('#fff')
      drawLine(v.title, 0, 20);
      doc.setTextColor('#000');
      addY(2)
      if (v.desc) {
        drawLine(v.desc, 0, 10);
      }
      doc.setFillColor('#fff')
      addY(6)
      cateToPage.set(v, getPage())
      // addY(3);
      if (v.contentId) {
        for (let j = 0; j < v.contentId.length; j++) {
          const id = v.contentId[j]
          if (contentList[id] === undefined) {// 前期调试问题方便，稳定后可以删除
            // debugger
          }
          await drawLine(contentList[id].content, 0, 10);
          // contIndex++;
        }
      }
      if (v.children) {
        for (let j = 0; j < v.children.length; j++) {
          const vv = v.children[j]
          if (getBottomY() < 20) {
            turnNewPage();// 不让类目标题位于某一页的最后一行
          }
          doc.setFillColor('#b6d7ff')
          doc.roundedRect(16, getY() + 5, pageWidth - 29, 10, 2, 2, 'F');
          addY(2)
          drawLine(vv.title, 0, 14);
          addY(2)
          if (vv.desc) {
            drawLine(vv.desc, 0, 10);
          }
          cateToPage.set(vv, getPage())
          if (vv.contentId) {
            for (let k = 0; k < vv.contentId.length; k++) {
              const id = vv.contentId[k]
              if (!contentList[id]) {
                ElMessage.error('存在失效的文章id，对应标题【' + vv.title + '】')
                return;
              }
              await drawLine(contentList[id].content, 0, 10).catch(e => {
                ElMessage.error(e)
                exporting.value = false;
                return;
              });
              // contIndex++;
            }
          }
          if (vv.children) {
            for (let k = 0; k < vv.children.length; k++) {
              const vvv = vv.children[k]
              if (getBottomY() < 20) {
                turnNewPage();// 不让类目标题位于某一页的最后一行
              }
              doc.setFillColor('#dfebff')
              addY(1)
              doc.roundedRect(18, getY() + 3, pageWidth - 31, 8, 2, 2, 'F');
              drawLine(vvv.title, 0, 12);
              addY(1)
              if (vvv.desc) {
                drawLine(vvv.desc, 0, 10);
              }
              cateToPage.set(vvv, getPage())
              if (vvv.contentId) {
                for (let kk = 0; kk < vvv.contentId.length; kk++) {
                  const id = vvv.contentId[kk]
                  await drawLine(contentList[id].content, 0, 10);
                  // contIndex++;
                }
              }
            }
          }
        }
      }
    }
    contEndPage = getPage()
  })();

  // 开始写目录
  (function () {
    const marginTop = 12;
    const marginBottom = 12;
    const marginLeft = 20;
    const marginRight = 20;
    const lineHeight = 10;
    doc.addPage();
    doc.setFontSize(22);
    doc.setTextColor('#000');
    doc.text('目录', pageWidth / 2, 25, {
      align: 'center',
    });
    let lineY = 30;
    doc.setTextColor('#000');
    doc.setFontSize(10);
    let pageCount = 1
    const singleXingWidth = doc.getTextWidth('**********') / 10;
    function drawCateLine(str: CateItem, x: number) {
      const y = lineY + marginTop + lineHeight;
      // doc.html('<div>文字</div>')
      // doc.html('<div style="font-weight: bold;">文字</div>')
      doc.text(str.title.replace(/。$/, ''), x + marginLeft, y);
      const beginX = doc.getTextWidth(str.title) + x + marginLeft;
      const xingCount = Math.round((pageWidth - beginX - marginRight) / singleXingWidth);
      if (xingCount - 2 > 0) {
        doc.text(Array(xingCount - 2).fill('*').join(''), Math.ceil(beginX / singleXingWidth) * singleXingWidth, y + 1)
      }
      const pageCurrent = cateToPage.get(str)
      doc.text(pageCurrent ? pageCurrent.toString() : '', pageWidth - marginRight, y);
      lineY += lineHeight
      if (lineY > pageHeight - marginBottom - marginTop - lineHeight) {
        doc.addPage();
        pageCount++;
        lineY = 0;
      }
    }
    cateJSON.value.forEach(v => {
      drawCateLine(v, 0)
      if (v.children && v.children.length > 0) {
        v.children.forEach(vv => {
          drawCateLine(vv, 5);
          if (vv.children && vv.children.length) {
            vv.children.forEach(vvv => {
              drawCateLine(vvv, 10);
            })
          }
        })
      }
    })
    if (pageCount % 2 === 1) {
      // 正文开始不要用目录的反面
      doc.addPage();
      pageCount++;
    }
    for (let i = 0; i < pageCount; i++) {
      doc.movePage(contEndPage + 3 + i, 3 + i)
    }
  })();
  // 结尾封皮
  (() => {
    if (page % 2 === 0) {
      doc.addPage();
    }
    doc.addPage();
    const { drawLine, getBottomY, addY } = Content(0, doc);
    doc.setFontSize(13);
    doc.text('电脑端可在浏览器访问如下网址，阅读本专栏', pageWidth / 2, 20, {
      align: 'center',
    });
    doc.setFontSize(12);
    doc.text('https://www.microbook123.com/book/' + bookInfo.value.id, pageWidth / 2, 27, {
      align: 'center',
    });
    // 两个app图标，等ios上线后，可以添加
    (() => {
      // doc.setFontSize(13);
      // doc.text('手机端可在app上阅读本专栏', pageWidth / 2, 40, {
      //   align: 'center',
      // });
      // doc.setFontSize(12);
      // doc.text('ios', 50, 47, {
      //   align: 'center',
      // });
      // doc.text('Android', 100, 47, {
      //   align: 'center',
      // });
      // const androidScanImg = 'https://img1.baidu.com/it/u=2990740733,444721965&fm=253&fmt=auto&app=138&f=JPEG?w=600&h=400'//https://yingshijiaoyusystem.oss-cn-beijing.aliyuncs.com/microbook.png?x-oss-process=image/resize,m_fill,w_128,quality,q_60
      // doc.addImage(androidScanImg, 'PNG', 35, 50, 30, 30)
      // const iosScanImg = 'https://img1.baidu.com/it/u=2990740733,444721965&fm=253&fmt=auto&app=138&f=JPEG?w=600&h=400';//'https://yingshijiaoyusystem.oss-cn-beijing.aliyuncs.com/microbook.png?x-oss-process=image/resize,m_fill,w_128,quality,q_60'
      // doc.addImage(iosScanImg, 'PNG', 85, 50, 30, 30)
    })()

    doc.setTextColor('#666');
    const bottom = getBottomY()
    addY(bottom - 40)
    drawLine('**声明：**本专栏由微述网站发布，内容非出版物，网站不售卖任何纸质内容，所有纸质内容均为用户在网站下载后个人打印产生，任何个人打印后仅供个人学习使用，不得售卖。', 2, 11);
  })()

  if (isUpload) {
    try {
      const blob = doc.output('blob');
      console.log('blob')
      console.log(blob)
      const formData = new FormData()
      formData.append('file', blob)
      const res = await post('/microbook/uploadFile', formData)
      console.log(res)
      if (res.result === true) {
        const saveRes = await put(`/bookInfo/${bookId.value}`, {
          data: {
            downUrl: res.url,
            status: 1,
          }
        })
        bookInfo.value.downUrl = res.url;
        console.log(saveRes)
        if (saveRes) {
          exporting.value = false;
          ElMessage.success('地址生成成功')
        }
      }
    } catch (e: any) {
      exporting.value = false;
      ElMessage.error(e.toString())
    }
  } else {
    exporting.value = false;
    doc.save(bookInfo.value.name + '.pdf');
  }
}
function getContentItemLength(cate: CateItem) {
  let length = cate.length || 0;
  if (cate.children) {
    cate.children.forEach(v => {
      length += getContentItemLength(v);
    })
  }
  return length;
}
async function initAddCate1Child(cate: CateItem, cateStrs: string[]) {
  if (!bookInfo.value) {
    return;
  }
  if (!cate.desc) {
    ElMessage.warning('章节需要有短描述')
    return;
  }
  addCate1ChildCateEditCat.value = cateStrs;
  addCate1ChildCateVisible.value = true
  addCate1ChildCateLoading.value = true;
  addChate1Session = new Session(bookInfo.value.createUserSystem);
  addCate1ChildCateAnswer.value = ''
  addCate1ChildCateAnswerJSON.value = ''
  const demand = ({
    [1]: '',
    [2]: `采用时间线作为章节划分`,
  })[bookInfo.value.cateType]
  addCate1ChildCateAnswer.value = await addChate1Session.chat(`你现在正在写一本《${bookInfo.value.name}》的书，本书的作用是${bookInfo.value.desc}。
其中${addCate1ChildCateEditCat.value.join('/')}章节负责讲述“${cate.desc}”这个目标，为了讲明白这个目标，需要生成下一级章节。${demand}。
  `, (res) => {
    addCate1ChildCateAnswer.value += res;
  });
  addCate1ChildCateLoading.value = false;
}
async function addCate1ChildCate() {
  if (!bookInfo.value || !addChate1Session) {
    return;
  }
  addCate1ChildCateLoading.value = true;
  addCate1ChildCateAnswer.value = ''
  addCate1ChildCateAnswerJSON.value = '';
  addCate1ChildCateAnswer.value = await addChate1Session.chat(`本书${addCate1ChildCateEditCat.value.join('/')}章节，我要它的设置下属一级章节。
  我的想法是：` + addCate1ChildCateInput.value + `。
  你的修改策略，根据我的想法，${addCate1ChildCateEditCat.value.join('/')}章节，新的下属章节列表`, (res) => {
    addCate1ChildCateAnswer.value += res;
  })
  addCate1ChildCateLoading.value = false;
  addCate1ChildCateInput.value = '';
}
async function createCatJSON() {
  if (!bookInfo.value || !addChate1Session) {
    return;
  }
  addCate1ChildCateLoading.value = true;
  addCate1ChildCateAnswer.value = ''
  addCate1ChildCateAnswerJSON.value = ''
  const youhuaStr = addCate1ChildCateInput.value;
  addCate1ChildCateAnswerJSON.value = await addChate1Session.chat(
    `${youhuaStr ? ('我的想法是：' + youhuaStr) : '可以了，这个章节我很满意'}，帮我生成${addCate1ChildCateEditCat.value.join('/')}章节子章节列表的json数据。
## 格式示例
\`\`\`json
[
  {
    "title":"第一章名称",
    "desc": "第一章内容短描述"
  },
  {
    "title":"第二章名称",
    "desc": "第二章内容短描述"
  }
]
\`\`\`
## 格式要求
返回json结构的title，不要加自增的序列，例如：“第一章：XXX”、“一、”、“1.”。title就直接是章节名。
json结构不要添加children层，只返回${addCate1ChildCateEditCat.value.join('/')}下一层目录。`,
    (res) => {
      addCate1ChildCateAnswerJSON.value += res;
    })
  console.log(addCate1ChildCateAnswerJSON.value);
  addCate1ChildCateLoading.value = false;
  addCate1ChildCateInput.value = '';
}
async function useAnswerJSON() {
  if (!addCate1ChildCateAnswerJSON.value) {
    return;
  }
  console.log(addCate1ChildCateAnswerJSON.value);
  const match = addCate1ChildCateAnswerJSON.value.match(/```json([\S|\s]+)```/);
  if (match) {
    let children = JSON.parse(match[1]);
    if (children.length === 1 && children.children && children.children.length) {
      children = children.children;
    }
    console.log('children===', children);
    let find: CateItem = {
      title: '',
      desc: '',
      length: 0,
      children: cateJSON.value
    };
    for (let i = 0; i < addCate1ChildCateEditCat.value.length; i++) {
      console.log(i, addCate1ChildCateEditCat.value[i], find);
      const match = find.children.find(v => v.title === addCate1ChildCateEditCat.value[i])
      if (match) {
        find = match;
      }
    }
    console.log('find=======', find)
    find.children = children
    addCate1ChildCateEditCat
    addCate1ChildCateAnswerJSON.value = ''
    addCate1ChildCateVisible.value = false;
  } else {
    ElMessage.error('无法找到json')
  }
}
async function deleteCate1(cate1: CateItem) {
  const findIndex = cateJSON.value.indexOf(cate1);
  if (findIndex > -1) {
    cateJSON.value.splice(findIndex, 1)
  }
}
async function deleteCate2(cate1: CateItem, cate2: CateItem) {
  const findIndex = cate1.children.indexOf(cate2);
  if (findIndex > -1) {
    cate1.children.splice(findIndex, 1)
  }
}
async function deleteCate3(cate2: CateItem, cate3: CateItem) {
  const findIndex = cate2.children.indexOf(cate3);
  if (findIndex > -1) {
    cate2.children.splice(findIndex, 1)
  }
}
function textSelect(event: any) {
  // 获取被选中的文本
  const selection = event.target.value.substring(event.target.selectionStart, event.target.selectionEnd);
  if (selection) {// 有selection证明是框选后抬起的鼠标
    console.log('框选')
    newContentOldSelect.value = {
      start: event.target.selectionStart,
      end: event.target.selectionEnd
    }
    newContentOldSelectText.value = selection;
  } else {// 有selection证明是取消框选后抬起的鼠标
    console.log('不框选')
    newContentOldSelect.value = { start: 0, end: undefined }
    newContentOldSelectText.value = ''
  }
}
function showMsgNotification(title: string, msg: string) {
  // @ts-ignore
  const Notification = window.Notification || window.mozNotification || window.webkitNotification;
  if (Notification) { //支持桌面通知
    if (Notification.permission == "granted") {
      //已经允许通知                        
      const instance = new Notification(title, {
        body: msg,
        icon: "https://www.haolizi.net/skin/images/150x50_logo.png",
      });
      instance.onclick = function () {
        instance.close();
      };
      instance.onerror = function () {
        console.log('onerror');
      };
      instance.onshow = function () {
        console.log('onshow');
      };
      instance.onclose = function () {
        console.log('onclose');
      };
    } else {
      Notification.requestPermission(function (status) {
        if (status === "granted") {
          //用户允许                                
          const instance = new Notification(title, {
            body: msg,
            icon: "images/reload.png"
          }); instance.onclick = function () {
            // Something to do                                
          };
          instance.onerror = function () {
            // Something to do
          };
          instance.onshow = function () {
            // Something to do
          };
          instance.onclose = function () {
            // Something to do 
          };
        } else {
          //用户禁止
          return false
        }
      });
    }
  } else {
    // debugger
  }
}
async function pushBaidu() {
  if (!bookInfo.value) {
    return;
  }
  const result = await get('/book/admin/pushToBaidu/' + bookInfo.value.id);
  console.log(result);
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (bookInfo.value)
          ? (_openBlock(), _createBlock(_unref(ElButtonGroup), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  size: "large",
                  type: "primary",
                  disabled: lockPage.value || cateJSON.value.length === 0,
                  loading: lockPage.value,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (createAllContent()))
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("批量补充正文", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (bookInfo.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "back",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).back()))
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("img", { src: _imports_0 }, null, -1)
              ]))]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(bookInfo.value.name), 1),
              (allBookLength.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(allBookLength.value) + "字", 1))
                : _createCommentVNode("", true),
              _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cateJSON.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["cateItem", { active: chooseCateInfo.value === item }]),
              onClick: ($event: any) => (lockPage.value === false && changeChooseCate(item, [item.title]))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(ElInput), {
                  class: "titleInput",
                  disabled: lockPage.value,
                  modelValue: item.title,
                  "onUpdate:modelValue": ($event: any) => ((item.title) = $event)
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
                _createElementVNode("span", _hoisted_10, _toDisplayString(getContentItemLength(item)) + "字", 1),
                _createVNode(_unref(ElDropdown), {
                  class: "tools",
                  disabled: lockPage.value
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_unref(ElDropdownMenu), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElDropdownItem), {
                          onClick: ($event: any) => (initAddCate1Child(item, [item.title]))
                        }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode("增加二级", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_unref(ElDropdownItem), {
                          onClick: ($event: any) => (deleteCate1(item))
                        }, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createTextVNode("删除", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _cache[16] || (_cache[16] = _createElementVNode("span", null, "操作", -1))
                  ]),
                  _: 2
                }, 1032, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(ElInput), {
                  modelValue: item.desc,
                  "onUpdate:modelValue": ($event: any) => ((item.desc) = $event),
                  type: "textarea",
                  autosize: "",
                  disabled: lockPage.value
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (item2) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["cateItem", { active: chooseCateInfo.value === item2 }])
                  }, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (lockPage.value === false && changeChooseCate(item2, [item.title, item2.title]))
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_unref(ElInput), {
                          class: "titleInput",
                          disabled: lockPage.value,
                          modelValue: item2.title,
                          "onUpdate:modelValue": ($event: any) => ((item2.title) = $event)
                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(getContentItemLength(item2)) + "字", 1),
                        _createVNode(_unref(ElDropdown), {
                          class: "tools",
                          disabled: lockPage.value
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_unref(ElDropdownMenu), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElDropdownItem), {
                                  onClick: ($event: any) => (toCate1(item, item2))
                                }, {
                                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                    _createTextVNode("变为一级", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_unref(ElDropdownItem), {
                                  onClick: ($event: any) => (initAddCate1Child(item2, [item.title, item2.title]))
                                }, {
                                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                    _createTextVNode("增加三级", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_unref(ElDropdownItem), {
                                  onClick: ($event: any) => (deleteCate2(item, item2))
                                }, {
                                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createTextVNode("删除", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _cache[20] || (_cache[20] = _createElementVNode("span", null, "操作", -1))
                          ]),
                          _: 2
                        }, 1032, ["disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_unref(ElInput), {
                          modelValue: item2.desc,
                          "onUpdate:modelValue": ($event: any) => ((item2.desc) = $event),
                          type: "textarea",
                          autosize: "",
                          disabled: lockPage.value
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ])
                    ], 8, _hoisted_13),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.children, (item3) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["cateItem", { active: chooseCateInfo.value === item3 }]),
                          onClick: ($event: any) => (lockPage.value === false && changeChooseCate(item3, [item.title, item2.title, item3.title]))
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_unref(ElInput), {
                              class: "titleInput",
                              disabled: lockPage.value,
                              modelValue: item3.title,
                              "onUpdate:modelValue": ($event: any) => ((item3.title) = $event)
                            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
                            (item3.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(item3.length) + "字", 1))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(ElDropdown), {
                              class: "tools",
                              disabled: lockPage.value
                            }, {
                              dropdown: _withCtx(() => [
                                _createVNode(_unref(ElDropdownMenu), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElDropdownItem), {
                                      onClick: ($event: any) => (toCate2(item, item2, item3))
                                    }, {
                                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                        _createTextVNode("变为二级", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_unref(ElDropdownItem), {
                                      onClick: ($event: any) => (deleteCate3(item2, item3))
                                    }, {
                                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                        _createTextVNode("删除", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _cache[23] || (_cache[23] = _createElementVNode("span", null, "操作", -1))
                              ]),
                              _: 2
                            }, 1032, ["disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_unref(ElInput), {
                              modelValue: item3.desc,
                              "onUpdate:modelValue": ($event: any) => ((item3.desc) = $event),
                              type: "textarea",
                              autosize: "",
                              disabled: lockPage.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ])
                        ], 10, _hoisted_18))
                      }), 256))
                    ])
                  ], 2))
                }), 256))
              ])
            ], 10, _hoisted_8))
          }), 256))
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [
        (showContentLoading.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, null, 512)), [
              [_directive_loading, true]
            ])
          : (showContent.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (chooseCate.value && chooseCate.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, " 请选择左侧的章节 "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _cache[25] || (_cache[25] = _createElementVNode("div", null, "创建目录后，未生成内容，点击生成进行创建", -1)),
                      _createElementVNode("div", null, [
                        _withDirectives((_openBlock(), _createBlock(_unref(ElButton), {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (createContent())),
                          style: {"width":"350px","margin-top":"12px"},
                          type: "primary"
                        }, {
                          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                            _createTextVNode("AI生成", -1)
                          ]))]),
                          _: 1
                        })), [
                          [
                            _directive_loading,
                            createContentLoading.value && !lockPage.value,
                            void 0,
                            {
                              fullscreen: true,
                              lock: true
                            }
                          ]
                        ])
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showContent.value, (contentItem) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _cache[27] || (_cache[27] = _createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1)),
              _createElementVNode("div", _hoisted_29, " 字数" + _toDisplayString(contentItem.length), 1),
              _createVNode(_unref(ElButtonGroup), { size: "small" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElButton), {
                    onClick: ($event: any) => (saveContent(contentItem))
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode("保存", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_unref(ElInput), {
                type: "textarea",
                onMouseup: textSelect,
                modelValue: contentItem.content,
                "onUpdate:modelValue": ($event: any) => ((contentItem.content) = $event),
                autosize: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]))
        }), 256))
      ])), [
        [_directive_loading, lockPage.value]
      ])
    ]),
    _createVNode(_unref(ElDialog), {
      modelValue: addCate1ChildCateVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addCate1ChildCateVisible).value = $event)),
      title: "增加二/三级章节",
      width: "1000"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(addCate1ChildCateEditCat.value), 1),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_unref(ElInput), {
            modelValue: addCate1ChildCateInput.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addCate1ChildCateInput).value = $event)),
            disabled: addCate1ChildCateLoading.value
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_unref(ElButtonGroup), { style: {"flex-shrink":"0","margin-left":"8px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElButton), {
                onClick: addCate1ChildCate,
                loading: addCate1ChildCateLoading.value
              }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                  _createTextVNode("沟通", -1)
                ]))]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_unref(ElButton), {
                onClick: createCatJSON,
                loading: addCate1ChildCateLoading.value
              }, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                  _createTextVNode("生成", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          innerHTML: addCate1ChildCateAnswer.value.replace(/\n/g, '<br/>')
        }, null, 8, _hoisted_32),
        (addCate1ChildCateAnswerJSON.value && !addCate1ChildCateLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createVNode(_unref(ElInput), {
                modelValue: addCate1ChildCateAnswerJSON.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addCate1ChildCateAnswerJSON).value = $event)),
                type: "textarea",
                rows: 10
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(ElButton), {
                onClick: useAnswerJSON,
                disabled: addCate1ChildCateLoading.value
              }, {
                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                  _createTextVNode("应用", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: newContentVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newContentVisible).value = $event)),
      title: chooseCate.value.join(' > '),
      width: "1000",
      class: "newContentDialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_unref(ElInput), {
            disabled: newContentLoading.value,
            modelValue: newContentInput.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newContentInput).value = $event)),
            placeholder: "输入告知AI的改进建议"
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(_unref(ElButton), {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (getNewContent())),
            disabled: newContentInput.value === '',
            loading: newContentLoading.value,
            style: {"margin-left":"4px"},
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
              _createTextVNode("生成", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, "字数:" + _toDisplayString(newContentOldContent.value?.content.slice(newContentOldSelect.value?.start,
          newContentOldSelect.value?.end).length), 1),
            _createElementVNode("div", {
              class: "countText",
              innerHTML: newContentOldContent.value?.content.slice(newContentOldSelect.value?.start,
          newContentOldSelect.value?.end).replace(/\n/g, '<br/>')
            }, null, 8, _hoisted_38)
          ]),
          _createElementVNode("div", _hoisted_39, [
            (newContentLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, "内容生成中，请稍等"))
              : _createCommentVNode("", true),
            (newContentNewContent.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, "字数:" + _toDisplayString(newContentNewContent.value.length), 1))
              : _createCommentVNode("", true),
            _createVNode(_unref(ElInput), {
              modelValue: newContentNewContent.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newContentNewContent).value = $event)),
              disabled: newContentLoading.value,
              type: "textarea",
              autosize: ""
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_unref(ElButton), {
            disabled: newContentNewContent.value === '' || newContentLoading.value,
            type: "primary",
            onClick: useNewContent
          }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
              _createTextVNode("应用", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_unref(ElDialog), {
      modelValue: newImgVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newImgVisible).value = $event)),
      title: "生成配图",
      width: "1000",
      class: "newContentDialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baiduImgList.value, (imgUrl) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (addImgToContent(imgUrl))
            }, [
              _createElementVNode("img", {
                src: imgUrl,
                style: {"width":"100px"}
              }, null, 8, _hoisted_45)
            ], 8, _hoisted_44))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})